export const RECRUITMENT_EVENT_CATEGORY = {
  RECRUITMENT_CATEGORY: "Recruitment"
};
export const RECRUITMENT_EVENT_ACTION = {
  APPLY_VACANCY_VIA_WHATSAPP: "ApplyVacancyViaWhatsApp",
  COPY_APPLICATION_LINK_VIA_WHATSAPP: "CopyApplicationLinkViaWhatsApp",
  SEND_INDIVIDUAL_INVITE_VIA_WHATSAPP_SUCCESS: "SendIndividualInviteViaWhatsAppSuccess",
  SEND_BULK_INVITE_VIA_WHATSAPP_SUCCESS: "SendBulkInviteViaWhatsAppSuccess",
  ATTENDANCE_CONFIRMED_INDIVIDUAL: "AttendanceConfirmedIndividual",
  ATTENDANCE_CONFIRMED_BULK: "AttendanceConfirmedBulk",
  DOWNLOAD_CANDIDATE_REPORT_VIA_WHATSAPP: "DownloadCandidateReportViaWhatsApp",
  INVITE_ONBOARDING_IN_BULK_BEGIN: "InviteOnboardingInBulkBegin",
  INVITE_ONBOARDING_IN_BULK_SUCCESS: "InviteOnboardingInBulkSuccess",
  INVITE_INDIVIDUAL_ONBOARDING_BEGIN: "InviteIndividualOnboardingBegin",
  INVITE_INDIVIDUAL_ONBOARDING_SUCCESS: "InviteIndividualOnboardingSuccess"
};
export const RECRUITMENT_EVENT_LABEL = {
  SUCCESS: "SUCCESS"
};
